// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 start
import { instanceApi } from 'libs';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import {
  GetEducationStatusRequest,
  GetEducationStatusResponse,
  GetNewentrantEducationRequest,
  GetNewentrantEducationResponse,
  GetUpperCooperatorListRequest,
  GetUpperCooperatorListResponse,
  GetSendoffEducationRequest,
  GetSendoffEducationResponse,
  EducationNewentrantRegisterRequest,
  EducationSendoffRegisterRequest,
  // 2023/12/25 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
  EducationStatusRequest,
  EducationStatusResponse,
  EducationApprovalRegisterRequest,
  EducationSendphotoRequest,
  // 2023/12/25 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
} from 'types';

export const getEducationStatus = (
  params: GetEducationStatusRequest
): AxiosPromise<GetEducationStatusResponse> => {
  const request: AxiosRequestConfig = {
    url: '/education/status',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getNewentrantEducation = (
  params: GetNewentrantEducationRequest
): AxiosPromise<GetNewentrantEducationResponse> => {
  const request: AxiosRequestConfig = {
    url: '/education/newentrant',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getUpperCooperatorList = (
  params: GetUpperCooperatorListRequest
): AxiosPromise<GetUpperCooperatorListResponse> => {
  const request: AxiosRequestConfig = {
    url: '/cooperator/upper_cooperator_list',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getSendoffEducation = (
  params: GetSendoffEducationRequest
): AxiosPromise<GetSendoffEducationResponse> => {
  const request: AxiosRequestConfig = {
    url: '/education/sendoff',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const educationNewentrantRegister = (
  data: EducationNewentrantRegisterRequest
): AxiosPromise => {
  const request: AxiosRequestConfig = {
    url: '/education/newentrant/register',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};
export const educationSendoffRegister = (data: EducationSendoffRegisterRequest): AxiosPromise => {
  const request: AxiosRequestConfig = {
    url: '/education/sendoff/register',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};
// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 end
// 2023/12/25 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
export const educationStatusList = (
  data: EducationStatusRequest
): AxiosPromise<EducationStatusResponse> => {
  const request: AxiosRequestConfig = {
    url: '/education/status_list',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};

export const educationApprovalRegister = (data: EducationApprovalRegisterRequest): AxiosPromise => {
  const request: AxiosRequestConfig = {
    url: '/education/approval/register',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};
// 2023/12/25 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
// 2024/01/08 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
export const educationSendphoto = (data: EducationSendphotoRequest): AxiosPromise => {
  const request: AxiosRequestConfig = {
    url: '/education/sendphoto',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};
// 2024/01/08 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end
